/**
 * Authentication-related constants for the Ray dashboard.
 */

/**
 * Event name dispatched when an authentication error occurs (401 or 403).
 * Listened to by App.tsx to show the authentication dialog.
 */
export const AUTHENTICATION_ERROR_EVENT = "ray-authentication-error";
